import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Modal from '../../../../core/modules/common/components/Modal';
import Button from '../../../../core/modules/common/components/Button';
import themeStyles from '../../../../materialUiTheme';

class SaveSelectionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      errorMessage: '',
    };
  }

  onSubmitSaveSelection = (e) => {
    this.setState({
      name: e.target.value,
    });
  };

  save = () => {
    const condition = this.props.selections.map(sel => sel.name).includes(this.state.name.trim());
    if (condition) {
      this.setState({
        errorMessage: 'A preset with this name already exists.',
      });
    } else {
      this.props.saveSelection({ name: this.state.name });
    }
  };

  render() {
    return (
      <Modal
        header={
          <FormattedMessage
            id={this.props.title}
            tagName="h3"
          />
        }
        closeOnOutsideClick
        onClose={this.props.closeModal}
      >
        <div className="admin-save-modal">
          <div style={{ width: '%100' }}>
            <input className="name-input" onChange={this.onSubmitSaveSelection} />
          </div>
          <p className="error-message">
            {this.state.errorMessage}
          </p>
          <div className="button-container">
            <Button text="app.button.cancel" onClick={this.props.closeModal} />
            <Button
              type="submit"
              text="app.button.save"
              style={themeStyles.blueButton}
              onClick={this.save}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

SaveSelectionModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  saveSelection: PropTypes.func.isRequired,
  title: PropTypes.string,
  selections: PropTypes.arrayOf(PropTypes.shape({
    scope: PropTypes.string,
    name: PropTypes.string.isRequired,
    impcCodes: PropTypes.arrayOf(PropTypes.string),
  })),
};

export default SaveSelectionModal;
